import { CommonData } from '../common_schema'

export const regionCountData: CommonData[] = [
  {
    name: 'Region Count per TiKV',
    mean: 'region_count_per_tikv:total.values.mean',
    std: 'region_count_per_tikv:total.values.std',
    location: 'TiKV-Summary --> Cluster --> Region'
  },
  {
    name: 'Region count growth rate',
    mean: 'NA',
    std: 'NA',
    location: 'NA'
  },
  {
    name: 'Store leader count',
    mean: 'leader_count_per_tikv:total.values.mean',
    std: 'leader_count_per_tikv:total.values.std',
    location: 'PD --> Statistics - balance --> Store leader count'
  },
  {
    name: 'Region heartbeat report',
    mean: 'region_heartbeat_Report:total.values.mean',
    std: 'region_heartbeat_Report:total.values.std',
    location: 'PD --> Heartbeat --> Region heartbeat report'
  },
  {
    name: 'heartbeat region event QPS(for update_cache)',
    mean: 'update_cache_count:total.values.mean',
    std: 'update_cache_count:total.values.std',
    location: 'PD --> Heartbeat --> heartbeat region event QPS(update_cache)'
  },
  {
    name: 'Active written leaders',
    mean: 'active_writting_leaders:total.values.mean',
    std: 'active_writting_leaders:total.values.std',
    location: 'TiKV-Details --> Servers --> Active written leaders'
  },
  {
    name: 'Hibernate peers(awaken)',
    mean: 'awaken:total.values.mean',
    std: 'awaken:total.values.std',
    location: 'TiKV-Details --> Servers --> Hibernate peers'
  },
  {
    name: 'Hibernate peers(hibernated)',
    mean: 'hibernated:total.values.mean',
    std: 'hibernated:total.values.std',
    location: 'TiKV-Details --> Servers --> Hibernate peers'
  },
  {
    name: 'Raft message(heartbeat+heartbeat_resp)',
    mean: 'heartbeat_message:total.values.mean',
    std: 'heartbeat_message:total.values.std',
    location: 'TiKV-Details  --> Raft message --> Message'
  },
  {
    name: 'Raft message(total)',
    mean: 'all_message:total.values.mean',
    std: 'all_message:total.values.std',
    location: 'TiKV-Details  --> Raft message --> Message'
  }
]
